/**
 * Pickleball match format catalog (Casual Arena defaults).
 * USA Pickleball / IFP traditional side-out: games to 11 (also 15/21), win by 2, typically best of 3.
 */

import { SPORT_IDS } from "../../../domain/sport/sportTypes";

/** @type {import("../../../domain/sport/sportMatchFormatCatalog").SportMatchFormatCatalog} */
export const PICKLEBALL_MATCH_FORMAT = Object.freeze({
  sportId: SPORT_IDS.PICKLEBALL,
  displayName: "Pickleball",
  matchTypes: [
    { id: "singles", title: "Singles", sub: "1v1", matchType: "singles", playersPerSide: 1 },
    { id: "doubles", title: "Doubles", sub: "2v2", matchType: "doubles", playersPerSide: 2 },
  ],
  setsOptions: [
    { setsToWin: 1, title: "1 Game" },
    { setsToWin: 2, title: "Best of 3" },
    { setsToWin: 3, title: "Best of 5" },
  ],
  pointsPresets: [
    { mode: 11, title: "First to 11" },
    { mode: 15, title: "First to 15" },
    { mode: 21, title: "First to 21" },
    { mode: "custom", title: "Custom" },
  ],
  defaultSetsToWin: 2,
  defaultPointsToWin: 11,
  customPoints: {
    min: 1,
    max: 21,
    label: "Custom points",
    placeholder: "1–21",
  },
  customSets: {
    min: 1,
    max: 5,
    label: "Custom best of",
    oddOnly: true,
  },
  pointsChipLabel: "Points",
  courtPresentationId: "pickleball.court.v1",
  intervalPresentationId: "pickleball.interval.v1",
  scoringSystem: "side_out",
});
